import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgShHl = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="flag-icons-sh-hl"
    viewBox="0 0 640 480"
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path fill="#006" d="M640 480V0H0v480z" />
    <path fill="#012169" d="M0 0h320v240H0Z" />
    <path
      fill="#fff"
      d="m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0Z"
    />
    <path
      fill="#c8102e"
      d="M212 140.5 320 220v20l-135.5-99.5Zm-92 10 3 17.5-96 72H0ZM320 0v1.5l-124.5 94 1-22L295 0ZM0 0l119.5 88h-30L0 21Z"
    />
    <path fill="#fff" d="M120.5 0v240h80V0ZM0 80v80h320V80Z" />
    <path fill="#c8102e" d="M0 96.5v48h320v-48zM136.5 0v240h48V0Z" />
    <path
      fill="#128bbf"
      d="M581.1 197c-.2 67.8-11 141-99.4 175.8-88.5-34.9-99.3-108-99.5-175.8z"
    />
    <path
      fill="#e8ece9"
      d="M481.7 372.8c40-15.8 65-41.6 79.3-69-2.2-.8-6.8-.9-8.6-.2-2.2-.2-85.5-6.3-95.3-9.9-8.6-3-41 2.7-56.2 8 14.1 29.3 38.6 54.5 80.8 71z"
    />
    <path
      fill="#69522b"
      d="M419.8 330.7c1.4-.4 4-.3 5-.2 1.2.3 1.4.4 1.8-1 .4-1.2 1.4-.9 2.2-.3.7.7 2.7.4 3.5-.7q.9-1.4 1.7-.2c.8.7 1 .5 1.9.3.7-.2 2-1 2.7-2.3.6-1.2 1.6-1.6 2.1-1q.8 1 1.9 1c.8-.2 1 .6.9 1.5s.3 1.2 2.1-.3c1.7 1.6 2.2 1 2.2-.7a36 36 0 0 0-1-9c-.7-.9-1.4-3.3-1.5-5.3-.2-3.7-.2-3.9-4.7-6.1 0-1.3-.3-1.9-3.4-1.7 0-.4-.5-1.7-1.1-2.2s-.8-.8-.5-2.3c1.3.1 2.8-.1 3.5-1.2s3.3-.8 4.8-.2q2.1 1 6.4.3 1.8-1.2 5-2.9c1.9-1 2.4-1.5 2.5-3 .3-3.9-1-8.3-2.1-10.4s-1.5-4.6-3-7.9c-1.6-3.5-1.6-4.4-3.5-6.5-.5-.6-1-1.1-1.2-2.3a6 6 0 0 0-1.8-4c-3.3-3-4.6-12.6-5.9-19.8-.7-4-.2-13.7-2-15.2-2.9-2.4-4.3-2-6.3-2.7-1.4-2-2-5.8-3.3-9.3-2 .4-3.5 2.5-5 3.3-1.3.7-1.6.7-1.6 2.7s-1 4.6-3 7.6-5.2 2.2-8 6.7c-6-7.2-6-9.3-6.5-11.3s-1.4-2.5-4.8-5.4c0-.9-.4-4.3 0-6.3-2.6-2-4.4-1.7-5.6-.2s-2 3.8-4 4.7c-1 1.4-4.4 4.9-7.1 9 2.5 37.7 11 75 36.7 104.8"
    />
    <path
      fill="#bca76b"
      d="M581.1 197c.1-25.6-1.3-50.4-.7-72.1-33-14.7-76.6-17.7-98.7-17.7s-65.8 3-98.8 17.7c.6 21.7-.8 46.5-.7 72z"
    />
    <path
      fill="#cfa763"
      d="M387.6 226.6c1 1.7 3 4.7 3.2 6.3.8-1.6 1.4-2.3 1.5-3.2s1.3-3 1-4c-.5-1-.8-1.8.3-1 1.2.7 1 2 .8 4-.8 5.3-3 6.4-3.3 10 3.2 7.4.8 10.1 4.3 17.5.5.3 2-.3 2.4-.2 1.9-1.3 3.2-.8 5.9-.3 2.6.6 4 2.4 4 4s0 2 .5 3 1.7 2.5 1.4 3.6c-.2 1 .3 1.7.6 2.3s-.1 1.7-.5 2.5q-.7 1 1.1 3.3c1.3 1.6 4.4 8.4 4.4 12.4s.2 5.9 1.8 6.6c1.7.8 2.2 1.4 2 3.1s.8 10.7 1 12.1.7 1.1 1.4 1.9 1 1.6 3.2 1.6 4.3-.3 5.7 0c2 2.6 3.2 6.3 3.6 8.5.5 2.3.4 5.4 1.2 5.4s1.5.1 1.3-2.7-.4-3.2-1.4-4.6-1.5-2-1-3a5 5 0 0 0 .4-3.3c-.2-1-.5-2.7 1.3-.5l3 3.4q.7 1.4.6 3.5-.1 2 .9 1.2c.8-.7 1.7.4 1.3 1.8q-.6 2.1 1.4 2.7 1.9.5 2.2 1.7c.3 1 1.4 1.4 1.4-.5 0-2-.7-6-1.3-7.4-.5-1.3-1-4-1-5.7-.2-1.6-.5-2-1.3-2.4q-1.2-.4-1.5-1.6c-.1-.7-.8-1-1.2-1q-.8 0-1.2-1-.4-.6-1.1-.6c-.6 0-1.4.3-1.7-.6s-.7-2-1.2-2.8-1-.9-1.1-3.3c0-2.4-.1-2.8-.9-3.6-.7-.9-2-3.2-2.6-4.1-.5-1-1-2-1 0 0 2.1 0 3.2 1.2 4 1.3.7 1.7.7 1.1 1.8-.5 1 0 1.8.2 2.6.3.7.7 1.5 0 2.3s-1.3.5-1.2-.7q0-2-.8-3.6c-.6-1-1-1.6-1.7-1-.6.5-1.2-.1-.7-.6q.5-.6 0-1t0-1.3c.6-.7.6-1 .3-2.5s-2.7-9.1-3.8-10.8-1-3 .4-1.3 2.6 3.2 2.8 4.6q.1 2 .8 2.8.7.9 1-.8c.2-1.2 1-.8-.4-3-1.6-2.3-4.4-6.1-5.5-13-1-6.7-1.5-11.2-2.6-13-1-2-1.4-2.3-1.5-4s0-3.5-.8-4.8c-.7-1.3-1.3-1.5-1.4.4 0 2 .1 6.3.7 7s.2 2.7 0 3.8c0 1-1.7 2.2 1.8 4.3 1.4.9 1.2 2 1 2.8q-.1 1.3-1.2-.5t-2.3-2.8c-.7-.7-.9-1.1-.7-2.6 0-1.5.4-2.6 0-3.1s-.7-.1-1 .7c-.1.9-.3 3.3-.8 3.9q-.5 1-1-1.2t1-6a16 16 0 0 0 .5-8.3c-.7-3.3-.4-4.3-2.9-7s-5.3-5.2-6.5-8.6-1.4-6.3-2.7-7.8a18 18 0 0 0-4.4-4v-5q.1-1.8-2-1.7-1.9.6-3 3c-1 1.7-1.6 1-2.8 3.7-1.2 2.9-3 4.3-3 7.3z"
    />
    <path
      fill="#cfa763"
      d="M395.4 258.2c.9.5 1.7 1 3 .3s2.9-2.6 4.6-.7c1.7 1.8 2.7 4.8 2.7 7.2s0 6.8 2.7 9.3 4.2 5 4.3 8.3a56 56 0 0 0 1.6 9.5 8 8 0 0 0 2 3.7c.8.8 1.5 3.3 1.6 6 .1 2.5-.3 4.3 0 5.6s0 2.4-1 1.8c-1-.7-1.2-1-1.7-2-.6-1.2-1.2-1-.7.7s2.2 3.1 3.6 3.1 1.9.2 2.7 1c1 1 1 1.4 2.5 1.4 1.6 0 1.8 0 3.2.4s1.4.2 2.2 0q1.1-.3 2 1.8a34 34 0 0 1 1.9 6.4c0 1 0 2.2.8 3.3.7 1 .5 2.1-.4 1.5s-.8-.5-1.5-.4c-.7.2-1-.2-2-.7-.8-.6-.3-.4-1.1-1.7q-1.5-2.1-1.5-.8c0 1.3 0 2.2-.7 1.6q-.9-.7-1.5 0c-.6.6-.8 1-1.5 0-.6-1.2-1.4-1.2-2-1.4s-.7-.2-1-1.2q-.7-1.3-2.2-1.2-1.3 0-1.4-1-.4-1-1-1.4c-.5-.4-.3-1.1-.4-1.9s-.8-.4-1.2-.6-.8-.1-.8-1.2-.4-1.4-.7-2.2c-.4-.7 0-1.5.2-2.3.2-1 0-1.4-.6-2.2s0-1.5-1.8-3c-1.7-1.5-2.6-.2-3.2-3.8-.5-3.6-1.6-11-2.6-12.1q-1.3-1.8-2.6-2.4c-1-.3-1.6 0-1.7-2.1-.1-2-.8-4.7-2-6l-2.6-2.2c-.6-.6-.9-1.6 0-3.4s.5-4.3.4-5.5-.4-2.7-.2-4 .1-2.9-.2-3.8-.8-1-.2-1.7"
    />
    <path
      fill="#d7c99c"
      d="M428.5 317.3c-.7 1.3-1.5.8-2.1.2s-1.4-.7-1.1-1.9.2-1.4-.6-2l-.4-.2h-1c-1.5 0-1.6-.5-2.5-1.3l-.5-.5v.8c0 1.2 0 1-1.2 1.3s-1-1.2-1.2-2.2l-.2-.5c-1.3-.3-2.7-1.7-3.2-3.1-.5-1.6.1-1.9.7-.8s.7 1.4 1.7 2 1.3-.4 1-1.7l-.1-1.4q-.3-.6-1-1c-1.7-.7-1.2-1-1-2.3q.1-2-1.4-.7-1.4 1.2-1.2-2.2c.2-3.4-1.4-2.2-1.7-.7s-.9.6-1.5-1.6-1.6-2.7-1.7-.6q0 2.6-1.7 1.1l.5 3.4c.6 3.6 1.5 2.3 3.2 3.8s1.2 2.2 1.8 3q1 1 .6 2.2c-.2.8-.6 1.6-.2 2.3.3.8.7 1.1.7 2.2 0 1 .4 1 .8 1.2l.9.1q.3-.6.8-1c1.3-1.4 3.3 0 4 1.6q1 2.6 2.3.8c1-1.3.7-1 1.8.1 1 1.2 1.5 1 1.5 1s1-.5 1.9.2c.7.6 1.2.5 2.6-1.5s-.7-1.4-1.3-.1"
    />
    <g fill="#7fb8c1" strokeWidth={4.2}>
      <path d="M429.4 332.4c2.6-.2 9.7-2.3 10.5-3 1.7 1.3 4.8 2.9 6 2.9q-3.6.6-4.7-.2c.3.7 1.2 1.9 1.7 2-2.4-.1-5-.6-6-1.5-2 .9-5.5 1-7.5-.2m4.7 3.2c1 .3 5.6 1 6.2 1-1.6 1.3-.3 2.6 2.3 2.4-1.3.1-2.6.6-1.7.8 2.2.4 8.3-1.2 9.5-1.9-2 2.7-12.1 5.1-16.3-2.3m4.2 6.6c1.2-.6 4.3-.4 5.8.3-1.7.6-4.9.6-5.8-.3" />
      <path d="M443 342.1c2.2-.4 8.5 1.1 10.7-.2-.8 2-4.7 2.2-6.1 1.8s-2.7-1-3.6-.9c.5-.3-.3-.3-1-.7m2.2 3c1.7.3 7.7-.4 9.6-1.1 2 .6 5.8 1.7 6.7 1.5-1.9 1.2-5.4.5-6.6 0a11 11 0 0 1-9.7-.3z" />
      <path d="M448.1 346.2q3.5.6 6.8-.7c.8.4 2.5.8 4.2.7 1 .6 2.5 1.5 4 1.6-1.5.6-7 0-8-.6a22 22 0 0 0-8.5 1.5c0-.7.4-1.8 1.5-2.5m-2.9-12.2c1.9.6 8.7.3 12.2-1.3 1.4-.6 2.2.4.6 1-5.6 2-10 2.7-13.3 1-1.3-.7-1.4-1.3.5-.7m33.4-9.2c-8.4 4-14 5-25.6 1.5-1-.3-1.8 0-.6.8 1.2.7 7.6 2.5 9.1 2.6 1.6 0 1 .8 0 1-.8.3-1.1 1 .1.5a22 22 0 0 1 11.1.8q1.8.8 1.5 0 0-.7 1.5-.9 1.6-.1.7-.7-1-.3-.2-.7t-.3-.7c-.8-.1-1.3-.3-.6-.7q1.4-.6 2.8-.8c.2-.6-.1-2.1.5-2.7" />
      <path d="M464.7 325.8c4.8.3 13.6-1.8 18.3-6.4 1.6 1 3.9 2 5 2.3 1.3.2 2.4 1.3.5 1.3s-4.5-.8-5.6-1.3c-6.3 3.8-13.5 5-18.1 4.6-1.3 0-1.6-.6-.1-.5m-7.6-13.5c-.6.1-3.4.8-4.2.7-.7 0-1.5.2-1.4.7 0 .5.2.9-1 .8-1-.2-2 .3-2.3.6s-.5.7.7.8c1.1 0 1.7.2 3-.4s2.6-1.5 4-1.6c1.4 0 2.8-1.9 1.2-1.6" />
      <path d="M453.2 315.6c1.2.8 7 2.8 9.2 2.6s1.7.9.1 1.2a13 13 0 0 1-10.1-2.9c-1.4-1-.1-1.4.8-.9" />
      <path d="M481 318.5c-4.4 1.4-9 1-10.9.4-1.8-.4-3.5-.6-2.3.6s5.3 2 7.6 1.4c-8.1 1.9-10.2 1.7-12.2 1.4a37 37 0 0 0-7.4-.1c-1.2 0-2.9 0-3.6-.5s-.9-1.3 1.2-1c2.1.2 2.4-.3.6-.5-1.9-.3-4.4.5-2 2 2.6 1.6 8 0 11.5.9a20 20 0 0 0 18-4c.3-.2 1-1-.4-.6zm-10.4-4.5c-1 0-2.6-.5-3.5-.9s-2-.4-1.2.8c1 1.3 5 2 6.4 1.4s.8-1.3 2.2-.4 3 1.4 4 1.4 1.4 0 .2-.6q-1.7-.7-1.8-1.4c0-.5-.3-.8.8-.5 1 .3 2.2 1 3 .5s2.4-1.4 3.7-1.4l.4-.8c-2-.2-3.3.4-3.8.6q-.9.4-2.6.2c-1-.2-2.4-.3-2.7-.5q-.6-.4.6-.7c.8-.2 1.1-.8 0-.5-1.3.2-4.5 0-6.2-.5s-2.4-.6-3-.3c-.8.3-.7 1 .4 1 1 .1 3.3.4 4.1 1.1q1.3 1.1-.2.4c-.9-.3-2.6-.1-.8 1.1m39.3-2.9c-3.2 2.4-7.1 3-11.8 3.2-1.4.1-1 .5.2.6 4.9.5 10.5-1.3 12.4-3.2.5-.6.5-1.5-.8-.6m-22.2 5.5a41 41 0 0 1 7.9 1.9q1.7-.2 1.3-.9c-.2-.4-.4-.9 1.8-.8h8c.8-.2 2.5-1.5 3.3-1.6-2 .1-10.1.6-11.2.4q-1.3-.1-2.2.4-.7.7-1.8.2c-.9-.3-2.3-.7-3.1-.2s-2.5 0-4 .6" />
      <path d="M506.8 316.9c.7-.3 2.4-1.6 3.2-1.7 1.4-.1 3 .5 3.8.6s1.6 0 1-.6c-.5-.6 0-1.7 2.2-1.4s3.4.7 5.6.4 3.1 1.4 7.2-.2c-.3 1.6.5 1.8 1.2 1.4q1.1-.6 3 .8c1.9 1.4 9.2 1 11 .7 2-.3 2.9.7 1.5 1.1q-2 .8-1.4 1.5c.3.5.6 1-1.1.8s-2 .3-3 1c-.8.6-1 .8-3.4.4s-2.9-.1-4.2.1-1.6.2-3-.2c-1.2-.5-4-.9-5.8-.3-1.7.5-3 1-4.5.6-1.6-.4-1.7-.2-.7-1.2s1.2-.8 3-1c1.9-.3 3.3-.8 2-1.6-1.3-.7-1.7-.6-3.5.2-1.7 1-2.6 1.4-4.5.4-2-1.1-3-.9-4.3-.6s-3.5-.4-5.3-1.2m6.5 3.2c-2.5.4-3.2-1.2-5.8-.9-.8.1-2.3 1.2-.3 1s4.2 1 6.2.8 1-1 0-.9zm-2.9 2c1.3-.6 4 .3 5.2.1 1.1-.2 2.2.5 1 .9s-4-.7-5.4-.3c-1.3.3-2.6-.1-.8-.8zm-26 6.9c1.8 0 8.3-.2 10.8-5.6q.2-.8 1.2 0c.9.4 3.9 2.2 9.5 2.7 1.5.2 3.2 1 0 .7-3-.2-8-1-9.8-2-2.8 4.3-7.9 4.9-11.7 4.8-2.3 0-1.7-.7 0-.6" />
      <path d="M498.4 321.6c-.9 1.2-3.9 3.3-5.2 3.4-1.4 0-5.5-.3-6.5-.7s-2.3-.2-.8.8 5.1 1.7 6.6 1.4c1.4-.3 3.1-.8 4.3-.1s3.2 2 4.5 1.8a11 11 0 0 1 4.6 0c.8.5 2.2 1.6.1 1s-3.8-.2-4.8-.6c1 1.5 3.5 4 5.6 4 .5 0 .9.8-.2 1.3 1 .5 3.4.9 4.7-.3q-.5.7.4 1c.5.3 1.2.6.2.7-1 .2-3.2.4-3.9.2a20 20 0 0 0 13.2 2.4c1.1-.2 1.7-.7 0-.6-3.7.1-3.9 0-4.5-.3q-1.1-.6.5-1c1-.4 3.6-.8 4.7-.8 1 0 2.2-.4 0-.4s-5 0-6-.4c-1.2-.3-2-.8-.9-1.6 1.2-.7 2.4-.5 3-1.2-3.7 0-8-2-5.6-3.7q.9-.5-.6-.5c-.9-.1-3.6-.9-4.7-1.6-1.2-.6-.4-1.1.5-1.3-2.1.4-6.4-.8-9.2-2.9m32 0c-2 1.4-5.7 2-7.3 2q-2.4.2-.5.7c1.2.1 2.6.3 3.1.1s.9-.2 1.7.2a6 6 0 0 0 4 .1c1.6-.5 4.1-.7 5.1-.6s2.2 0 .1-.5c-2-.6-5.4-.2-6.2 0s-3 0-1.9-.3a13 13 0 0 0 2.9-1.4zm-1.1 4.1a13 13 0 0 1-6.6 2.6c2.2.8 4.2 3.1 5.6 3q-1.1.8-2.5 1.2c1.4.4 3.8 0 5.8-1.1 3.2.9 7.5.3 8.9-1-2.1 0-4.7-.7-5.8-1.6q1.6-.2 2.5-1.3c-2.5.5-6.7-.7-7.9-1.8" />
      <path d="M525.8 332.5c1-.1 1.8-.8 2.5-1.2-1.8.6-9.6-.6-12-2.7-2.3-2-2.3-.5-.7 1 1.7 1.4 4.6 3.6 10.2 2.9m5.8 5c-1 .5-5.7.8-7.2.5q-2.3-.5-1.8.4c.4.6.6 1.2-.7 1s-3.5.1-4.4.4-2 1.2-.1.8c2-.3 3.7-.7 5.2-.3s6.7.5 7.7 0 .4-.4-.1-.4-.7-.3 0-.6 1.2-1.3 1.4-1.8m-45.3-6.3c-2 .9-8.5 2.6-10.2 2.7q-3.4 1.5-5 1.5a8 8 0 0 0 4.9 1c-.7.6-2.2 1.4-2.7 1.7 1.7-.2 3.8.2 4.7.3a13 13 0 0 1-7.1 1.5q.8 1.4 2.3 1.5c-2.1.6-4.6.6-6 .2q.9 1.6 2 1.8c-1.8.2-4 .5-5.8-.5q2.1 2.7 9.2 1.9c4.7-.5 8.6-2.6 9.7-3.5-2 .3-4.6.4-5.9.1a34 34 0 0 0 9.3-4q-1.7 0-3-.8a29 29 0 0 0 8.5-1c-2-.5-3.1-1.7-3.7-2.5a37 37 0 0 0 18.2.6c.9-.2 1-1.3-.8-1.2-3 .2-8.9-.7-10.4-1.4 1.4 1 3.1 1.7 4.3 2-2.8.7-6.7 1.2-12.5-2z" />
      <path d="M473.3 338.1c.5-.3 2-1 2.7-1.7a8 8 0 0 1-4.9-1q1.6 0 5-1.5c-4-.1-6.6-.1-8-.9-1.5-.7-4-.5-5-.3s-.7 1.8 3.4 1.4a14 14 0 0 1-8.1 1.2q.8 2.3.3 3.6a28 28 0 0 0 11.2 2.7c-2.6-1-4-2.1-1.8-2.3 2.1-.2 3.3-.7 5.2-1.2m-6.8 7c5.2-.4 12.2-.5 17.8-5.2 1.4-1.2 2.3-.8 1 .5-3 2.6-10.3 6.1-17.2 6.2-2.9 0-4.2-1.3-1.6-1.5m39-8.5c-1.3.5-5 1-6 1-1-.3-2.7-.3-3.5.2q-1.6.9.2 1l3.5.2c-1 .5-1.6 1.3-1.8 1.6 1.7-.4 5 .3 5.8.8q-1.1.3-2-.3c2.9 3 11.6 3 13 2.5q-1 .9-2 1.1c2.5.5 5.3.4 8.1-1.2-1 .2-3.7-.1-4.4-.2a5 5 0 0 1 2.1-1.2c-1-.2-4.5-.1-5.3.3q.6-1 1.6-1.7c-4.3 0-9.5 0-11.4-1 3 .2 6.4-1.5 7.8-1.5-2.4-.1-5-.6-5.7-1.6m-10.9 2.4c-2.1.4-5.3 1.3-6.2 1.7-.9.5-1.8.8.1.8l.7-.2c-.8 0-1.7 0-.3-.4 1.5-.5 3.3-1.5 5.7-2zm-4.3 5c.8 0 4 0 5.4-1.1 1.3 1 4 2.4 5.6 2.4 1.7 0 1.6.5 0 .6-1.4.2-4.3-.7-5.7-1.8-2 .8-3.6.2-5.3-.1m-25.2 14.5c3.4 1.3 7.9 2.3 11.1 1.2 1.9 1.6 5.7 1.7 7.7 1.3 2.1-.4 4-.7 6.2.1s7 .8 8.3 1.9c-1.2 0-3.7 0-4.3.2q-.9.2.8 1a23 23 0 0 0-12 3.1c.7-1.7 2.8-4 6.3-4-2-.6-8.3-.7-10.3.5a6 6 0 0 1-1.3-2.1c-3.3 1.9-9.9-.8-12.5-3.2m-8.6-6c4-.6 6.7-1.9 8-3 .6.6 3.6 1.2 6.8.3-.7.4-.7 1.4-.5 1.9-2 0-6.1 1-7.5 1.7-1.3.7-5.3 1.2-6.6.5q-2-1.1-.2-1.4" />
      <path d="M470.8 351.7c-2 0-6.1 1-7.5 1.7q.5 1 .5 2a48 48 0 0 1 16.3-1.7c-1.6.1-4.7 1.8-6.4 2a33 33 0 0 1 9.4.8q1.7.5.5 1.8c-1.2 1.3-1.2 1 .6 1s5.3-.2 7-1.8c-.7-.7-2.4-.4-3-.9a8 8 0 0 0 3-1.8c-3 0-4 0-5-.3s-1.7-.5-.5-1.1a7 7 0 0 0 2.2-1.6c-2.2.6-5.5 1-8.3-1.1 1 .2 3.5 0 4.4-.3q-1.4-.8-2.5-.9c2.3-1 6.7-2 12.1.2 2.7-.3 5.7-.2 7.7.4 1-.9 2.8-3 3.7-3.5-6.4.6-18-.6-17.7-4-2 2.7-6.8 4.2-9 3.8-.1 1 .7 2.2 1.5 2.8-2.2.5-5.9.8-7.6.5 1 1 2.8 1.8 3.9 1.7-2.3 0-3.5.4-5.3.3" />
      <path d="M484.2 359.3c1.7 0 5.3-.2 7-1.8-.7-.7-2.4-.4-3-.9a8 8 0 0 0 3-1.8c4.6-.3 8.7-.1 10.6-.7s7-.3 8-.6c-4.4.7-5.2 1.1-5.5 1.8s1.4 1.3 2.5 1.3c-2 0-4.4 2-4.6 2.8-2.7-1.5-3.9.2-4.2.8-1-.4-4.7-.3-6.5 1.3-2.4-.7-4-1.1-6.4-.7 1.5-.4 1.2-1.3-1-1.5zm20.8-12.7h5.9a7 7 0 0 0-2 1.4c3.7-.5 8.8-.7 10.2-.5-1.8-.3-3.6.9-4.5 1.5-1 .5-.4 1 .8 1 1.3.2 3 1.2.7.9s-6.8-.3-7.9-.2c-1 .2-1.7-.3-.1-.6q2.3-.4 3.4-1.1c-1.3.3-3.8.3-4.6 0s-1.2-.6-.3-.8.2-.5-.7-.4c-1 0-3.3 1-4.6 2.3q2.2-2.3 3.7-3.5m-16.5 2.5q2.4 3 7.2 3.2c.7 0 2 1 .4 1-4.6.2-6.9-.9-8.9-3.8-.4-.6.4-1.4 1.3-.4m58-24.6c-1.4 1-3.2 2.5-2 4.8l.4-.2a132 132 0 0 0 13.8-20.1v-.7a19 19 0 0 1-4.8 3c.6 1.6-2.4 4-4 4.6.6 1 .4 2.7-1 3 .3 1-.8 1-2 1.5q-2 .7-2.5 1.6c.7-.4 1.7-.7 2.2-.5s.7 1-.3 1.2q-1.5.4-2 1.1c1.5-.5 3.5-.2 2.1.7zm-96-24.6c1.7 1.1 4.6 3 8.3 2.7 1.9 1.5 4.7 2.7 6 3-2.5 1-5.2 1.9-5.9 2.7-1.1-1-2.6-1-3-1.5q-1.4 1.4-.2 1.9a22 22 0 0 0 7.6 1c1.3-.4 1.7.7.6 1-3 1.1-8.7.1-10.6-3s-3.7-4.3-9-1.4c-.6-1.6-.6-2-1.6-2s-3-1.3-1.5-1.2c1.5 0 5.8-.6 9.3-3.2" />
      <path d="M451.8 306.8c-.9.3-3.4 1.7-4.4 1.8-.9 0-2.5 1.4-.8 1.4s3.8-1.7 5-2c1.2 0 1.3-1.4.2-1.2m7.2 5.1v1.5c-.2.4-.2.9.5.4s1.2-1.2 1.9-.9c.7.4 2.5.4 3.3.3q1.4-.1-.1-.8a8 8 0 0 0-3-.6 5 5 0 0 1-2-.3q-.9-.3-.6.4m25.8.2-.4.8c2 0 7 .4 8.5 1.4 1.5-1.2 1.3-1.6 2.3-1.4 1.1.3 2.5.6 3.1.3q.8-.4 1.7-.1c.6 0 2-.2 2.9-.7s2.5-1.1 3.4-1.1c1 0 2.2-.2.4-.5a14 14 0 0 0-5.4.6c-1 .3-3.7.5-5.3.5-1.7 0-3.9.8-5.8.3s-4.4-.1-5.4-.1m30.9-.8c2.4 1.2 7.2 2.1 11 2 .6 0 2 .6.3.8q-6.3.7-11.6-2.2c-1-.5-.6-1 .3-.6m2.5 0q5.6-.3 7.6 1c2-.7 5.9-1 6.8-.9.8.2 1.8-.2-.2-.7s-6.7-.6-8.2-.3-6 .4-7.5.2q.8 0 1.5.7m14.3 1.4c1.7-.9 6.8 0 8.3-.7-1.1 1.3 3.5 1.4 7.4.4-1.5 1-4.8 1.1-6.2 1.7s-2.2.2-3.2-.3c-1.1-.5-3.9-1.4-6.3-1z" />
      <path d="M548.2 312.4c-4 1-8.5 1-7.4-.4-1.5.7-6.6-.2-8.3.7 1.8-1 3.2-.2 4.5-2.4.8.2 2.7.3 3.3-.6 1.2.3 3.2.8 3.8 1.4s1.5-.2.8-1.1c1.7-.7.6.7 4.8-.3.9-.2 3-.6 3.7-.6a26 26 0 0 1-5.2 3.3" />
    </g>
    <path
      fill="none"
      stroke="#000"
      strokeWidth={2}
      d="M581.1 197c-.2 67.8-11 141-99.4 175.8-88.5-34.9-99.3-108-99.5-175.8z"
    />
    <g strokeWidth={4.2}>
      <path
        fill="#cfa763"
        d="M421.7 227.5a22 22 0 0 1-5.1 5c-2 1.4-4.7 2.5-3.2 5 1.4 2.4 2.6 2.7 2.9 4.6s.7 3.4 2.2 3.9c1.4.4 2 .1 2 3.1s0 4.2 1.3 5.3c1.3 1.2 1.2 2.4 1.7 5 .6 2.8.6 8.7 2.4 12.8 1.7 4 5.6 11.6 5.2 13.2-.5 1.6-1 2.7.7 4.6s3 4.6 3 6.2c.2 1.6.5 2.2 2.2 1.6a7 7 0 0 0 3.2-1.9q1-1 3.4.3c1.6.9 4 1.7 5.5.9 1.4-1 2.1-2.2 3.4-2.2 2-1.4 2.8-4.5 3.2-5.3.5-.9.2-.9-.7-1.8s-.4-2.3-.6-3.7q0-2-2.4-6.8c-1.8-3.1-2.8-7-4-8-1.1-1-1.7-3.5-1.8-4.6-.2-1.2-1.5-2.2-2.4-3-.8-1-1.7-2.2-2.7-7.3s-1.8-8.6-1.8-9.5q.2-1-1-1.2c-.8-.3-1.3-1.8-1-2.5s-.3-1.4-.6-2.3 0-2.4.6-3.3.5-3.3-.1-5.3-1.2-3.8-3.5-4c-2.3-.4-2.8-1-3.6-2.8-.9-1.9-1.8-5.2-2-6-.4-.6-.8-.8-2.5.7-1.8 1.4-2.3 1.9-2.3 4.6 0 1.7.2 2.3.8 3.3s.7 1.3 1.2 4 2.9 7-.3 9.5-2.8 3-2.6 4.8-.9 2.8-1.5.4q-.8-3.5 1.8-5c1.7-1.2 3.3-2.6 2.1-4.2a17 17 0 0 1-1.7-7q0-2.9-1.4-1z"
      />
      <path
        fill="#d7c99c"
        d="M395.8 264.2q0 1.9.3 3.5c.1 1.2.4 3.7-.4 5.5-1 1.9-.7 2.8 0 3.4 1.8-.5 2-2.5 1.6-3.4q-.7-1.7.2-3.3.9-1.4 0-2.3c-.4-.7-.4-.7.2-2.7.5-1.8-.8-1.8-1.9-.7m18.6 28c-.4-1.4-1.6-6.3-1.7-9.6q0-4.7-4.2-8.3c-2.1-2-2.6-5-2.7-7.4q-2.4-1.5-2.1 1.2c.1 2 2 2.9 1.8 5.7-.3 2.8-.3 2.1 1 3.5q2.3 2.1 1.2 3.2c-.7.6-.8 1.6.2 2s1.1 1.4 1 2.4.8 1.2 1.4 2c.5.7.6 2.4 0 3.4s-.6 2.6.4 1.7c1-.8 1.5 0 2.2 1.3.7 1.2 1.3.8 2 .5l-.5-1.7zm-8.5-60c-1.1 0-1.8 1-1.2 4.3.4 2-1.2 1.5-1.8.5-.5-1-1-3.1-2.1-5s-.6 1.3-.8 3c-.1 1.7 1 1.7 2 3.2 1 1.4.2 2-1 2s-.5 2.3-.2 3.9-.3 1.9-1.2.6-.3-3.4-.1-5.8.3-1.9-1.3-2.4-1.4-1-.8-2.4 1.2-2.1.5-2.8q-1.2-1.1.5-1.3c1.2-.2.8-1 1.8-1.3s1.4.1 1.6-1.7c.1-1.6.6-2.6 1.8-2 .7 2.3 1.6 6 2.3 7.2m26.5 25.8c.4-3.1.1-6.3 1.4-7.4s3-3.5 2.8 1.4-.3 4.6-1.3 5.8c-1 1.1-1.9 1.4-.9 3.3s1.2 2 1 4.9c-.1 2.8-.1 4 1 5.4s1.5 1.6 1.8 3.2a10 10 0 0 0 2.6 4.9c1.3 1.1 2.8 4.5 2.9 6.8s2.2 2.8 4 4.4c2 1.6-.4 2.8-1.8 2-1.5-.7-.9 0-1.8 1s-1.1 1.2-1.9-.5c-.7-1.8-3.1-3-4.3-3.3-1.2-.5-2.2-2.3-3.2-4.2a6 6 0 0 0-4.2-3q.8 2 .6 2.7c-.5 1.6-1 2.7.7 4.6s3 4.6 3 6.2c.2 1.6.5 2.2 2.2 1.6a7 7 0 0 0 3.2-1.9q1-1 3.4.3c1.6.9 4 1.7 5.5.9 1.4-1 2.1-2.2 3.4-2.2 2-1.4 2.8-4.5 3.2-5.3.5-.9.2-.9-.7-1.8s-.4-2.3-.6-3.7q0-2-2.4-6.8c-1.8-3.1-2.8-7-4-8-1.1-1-1.7-3.5-1.8-4.6-.2-1.2-1.5-2.2-2.4-3-.8-1-1.7-2.2-2.7-7.3l-1.7-8.5q-1.5 2.4-2 1c-.5-1.4-1.1-2.1-1.7-1.2-.6.8-.7-.8-.7-1.5s-.1-.8-.9-.8c-.7 0-.1-1.2-.4-3.3-.3-2.2-.7-2.5-1 .1s-1.8 4.2-1.2 4.7q.8 1-.3 3.5a5 5 0 0 0 .2 3.9c.4 1.1-.3 3.3-.6 5.2-.3 1.8 1.2 3.7 1.6.5m-12-8.9c0 3 0 4.2 1.4 5.3 1.3 1.2 1.2 2.3 1.7 5s.6 8.7 2.4 12.8l2 4.3c.9-.8 1.7-2 2-2.8.5-1-.8-3-1.9-4.7s.2-2.3 1.2-4.5c1-2.1-.1-2.3-1.7-2.9-1.6-.5-1.6-2-2.5-4.3s-.7-3.3-.2-4.6q.9-2-1-2.6c-1.1-.3-.8-1.1-.4-2.6.4-1.4.7-1.7-1-1.3q-1.7.5-2 1z"
      />
    </g>
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.5}
      d="m447.9 248-3.5 38m14-14.8a272 272 0 0 1-5.3 20m50.7-38.3c2.7 2.5 6.2 3 10.1 5m7.4 11.9-2 14.6m0-14-3.4 15M456 271.7q-2.6 9.3-5.9 17.8"
    />
    <path
      fill="#666"
      d="m531.4 307-.3.1h-.6l-.3.1h-.3l-.3.1-.2.2-.2.2-.2.3-.2.2-.3.4-.1.1-.2.2-.1.2a5 5 0 0 1-2.7 1.2 8 8 0 0 1-3.1 0q-2.2.1-3.6-.7c-1-.5-2.2-.1-3 .3-.6.3-.7 1-1.4 1.1-.4.6-2.2.5-3 .3q-2 0-3.7-.8c-.7-.5-2-.9-2.8 0q-.8.8-2.2 1c-1.5 0-3.3.3-4.5-.3-1.3-.1-1.7-.8-3-1.2-1.3-.2-1.9.5-2.8.8q-1 .8-3.2.6c-1.4 0-3 .2-4-.4-1 0-1.8-.7-2.7-1.1-.8-.7-2.3 0-3 .4-1.3.2-1.7 1.1-3.3 1-1.3-.1-2.1-.7-3.3-1-1.1-.5-2-1.3-3.8-1.2q-1 1-2.9 1-1.5 0-2.8-.2c-2.1 0-3.1-2.3-4.6-3.5L451 299c.4-1.3.6-1.6-.1-2.5.2-1.3-.7-1.5-.3-2.8.6-1-1-.9-1.4-1.4-1-.2-1.3-.9-2.2-1.2l-2.3-1.3-2.2-1.1-1.8-1.3-1.7-1.4-1.8-1.1q-.9-.8-2-1.3c-.9-.3-1.7-1-2.8-1.2-.7 0-.9-1.6.4-1.5 1 0 1.5.6 2.2 1q1.6.8 3.5 1.2l2.3 1c.8.6 1.8.7 2.7 1.3.9.4 2 .8 2.4 1.3.8.3 1.2.8 2 1.1l1.3 1q1 .3 2 1 1 .4 1.7 1c.6.2 4.8 2.3 4.6 2 4.1.8 6 1 10 1.7l30.1.4 10.9-4.5 3.3-5.3 16.1-2.9c-.3-.3 28.2-1 28.8 1.4.3 1 1 3 .1 3.5-.6.3-27-3.3-27.3-1-.2 1 0 7.5.2 8.5l.4 3 .5 3.2.4 3z"
    />
    <g fill="none" stroke="#000" strokeWidth={0.5}>
      <path d="M449.8 266.6c-4.8 5.5-9.6 9.9-14.8 14.1m41.5-36.6 15.7-13.5m-22.7 26.9c3.1 2.2 6.6 4.1 11.4 5.3M467.3 237c2 3 4.2 6 11 7.9m-15.5-38.7a27 27 0 0 1-9.9 7.6m15.6 11.4a24 24 0 0 0 8.5 4.6m-8.5 42.5a229 229 0 0 0 4.7 20.3" />
      <path d="M467.2 292.5c8.1-8.4 15-17.3 19.6-27.6m16.6-30.1c2.6 2.7 5.3 4.8 9.5 6m1.8-16c2.2 4 4.9 6.9 7.4 10.1m-31.5-22.5c-.2 4-2.6 7.9-4.3 11.3" />
      <path d="M496.3 214.3c-3 3.3-5.7 6.7-9.7 8.7m10.2-22.7a36 36 0 0 1-7 3.7m36.6 26.2c-2.4 2.9-4.8 6.2-8.7 8.7m9.2 15c-3.1 3-5.9 6.4-9.4 8.6m27.1 8.3q-8.1 6.6-17.2 11.5m3 .5c5-3.2 9.7-7.6 14.2-12m-15.8-40c1 2.6 3.3 5.5 5.6 7.3" />
    </g>
    <path
      fill="#bca76b"
      stroke="#472b1f"
      strokeWidth={0.4}
      d="m525.5 205-.5 77.9 5.7-.3-2.4-77.9z"
    />
    <g stroke="#000">
      <path
        fill="#333"
        strokeWidth={1.3}
        d="m529.2 305.4 3.1 2.6c2.7 2.4 4.2 2.4 7.8 0 1.3.2 2.6 1 4 .7q2.1-.1 3.9-.5c1.4-.4 1.7-2.1 2.2-3.4.7-1.3 1.3-3 2.4-4.1 1.3-1 2.7-1.8 3.6-3.2q1.3-1.8.7-4.2l-.3-4c-.2-1.9 1.3-3.2 1-5-.7-.7-2.2-1-3.3-1.3a45 45 0 0 0-6.3-1l-5.3-.3-5-.3q-3-.1-5.8.1c-1.3.3-3 .2-4.2.8a14 14 0 0 0-.7 4l-.3 3.6c0 2.3-.3 4.5.4 6.6l1 5.2c0 1.4 0 2.7 1 3.7z"
      />
      <path
        fill="none"
        strokeWidth={0.5}
        d="m535.7 267.5 7.8 14.5m11.5.7q-3.3-3.6-5.4-8.5"
      />
    </g>
    <path
      fill="#472b1f"
      d="m554.5 260.2 2.6 1.8h.1c-.8-.7-1.6-1.6-2.7-1.8m-5.3.7-.3.1-3.6 14zm17 .6q-1.3.1-2.6.8l1.5-.5 2-.3h-1zm-16.6 12.7-.7.1a3 3 0 0 1 1.8.5zm1.4.7q1.3 1 2.8 1.6zm8.3.8-4.8 1q2.5-.2 4.8-1"
    />
    <path
      fill="#fff"
      d="m549.3 260-4 15 4.3-.9 4.5 2.6 6.8-1.4 3.5.5c1-4.8.7-10.4 3.5-14.5l-2.8.5-4.5 1.5-3.6-1.3-2.8-2z"
    />
    <path
      fill="#c8102e"
      d="M555.9 261.9a9 9 0 0 0-1.6 4.4l-3-.9h-3.4v.1l-1 3.6s2.7-.4 4-.2c.8.1 2.4 1 2.4 1l-1.3 5.6.9.5 1.8.5.8-.1q.5-3.2 1.5-5.4s2.8.7 4.3.6l3.8-.3.5-3.6c-.5.1-2.9.7-4.2.6a13 13 0 0 1-3.3-1.3q.5-1.8 1.4-3.7z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.7}
      d="M546.4 260c-1.9-5-4.1-13.1-5-19.6"
    />
    <g stroke="#472b1f">
      <path
        fill="none"
        strokeWidth={1.3}
        d="M548 261.2s4.4-1 6.3-.7c2 .4 3.1 2.6 5.2 3 2.3.3 4.2-1.8 6.6-2l3.3.3-1.6 5.5-1.3 4.6v4.1s-3.7-1-5.7-.6c-2.5.2-4.4 1.5-6.8 1.3-1.8-.4-2.6-1.9-4.5-2.3-1.3-.4-5 .6-5 .6z"
      />
      <g fill="#bca76b" strokeWidth={0.3}>
        <path d="m548.8 261-1.8.1-5.6 20 2.6.2z" />
        <path d="M547 261.1c-.8-.4-1.3-1.7-1-2.5.5-1 2-1.1 3-.8 1.1.3 2.6 1.4 2.2 2.5-.4 1.3-3 1.5-4.2.8z" />
      </g>
    </g>
    <path
      fill="#472b1f"
      d="M567.7 261.6c-2.7 4-2.5 9.3-3.5 14l2.3.4v-4l1.4-4.7 1.5-5.4z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.5}
      d="M535.4 245.3c2.9 2 5.7 7 9.7 11m-4.4-18.3a78 78 0 0 1-4-21m-4.2 53.2 4.4 11.6m0-70.3c-3.9-1-7.5-3.6-8-5.8m-17 9.6c2.5.2 11.2-6.2 12.5-9.6m9.6 62.8 6.1 13m-6.6-8.6 4.5-1.6m-3.7 4 4.7-2m-2.8 7 5.2-2.2m-10.5-23.5 6.3 6.7m-19.5 9.5-4.3 14.5m3.1-11.3h4.4m-5.4 3.6 5 .1m-6.2 3.6 5.5 1"
    />
    <g fill="#bca76b" stroke="#472b1f">
      <path
        strokeWidth={0.4}
        d="M528.8 203c-1-.3-3.8-.4-4.9.5-.5.4 0 2 .7 2 1.4 0 3.3 0 4-.3.5-.5.9-2 .2-2.2z"
      />
      <path strokeWidth={0.5} d="M513 215.2c1.9 7.6 9.9 6.3 9.6-.6" />
      <path strokeWidth={0.7} d="M520.4 214.8c2.5 8.8 13 7.4 12.5-.6" />
      <path
        strokeWidth={0.5}
        d="M529.3 214.7c2.4 6.4 5.7 5.2 9.7-.7m2.3-2.3-29.6 1.7v2l30-1.6zM514 241.4c2 8.2 10.3 7 10-.6"
      />
      <path strokeWidth={0.7} d="M521.8 241c2.4 9.7 13.3 8.2 12.9-.4" />
      <path
        strokeWidth={0.5}
        d="M531 241c2.4 7 5.8 5.7 10.1-.6m2.4-2.4-30.7 1.2v2.2l31-1.1zm-30.2 26.9c2 8.6 10.5 7.2 10.2-.7"
      />
      <path strokeWidth={0.7} d="M521.2 264.6c2 12.7 13.8 8.1 13.2-1" />
      <path strokeWidth={0.7} d="M530.6 264.3c2.7 7.2 6.2 5.8 10.4-.8" />
      <path strokeWidth={0.5} d="m543.5 261-31.5 1.8v2.2l31.8-1.7z" />
      <path
        strokeWidth={0.3}
        d="m533 226.9-11.7.3v3l11.8-.1zm0 24.7-11.6.3v3l11.8-.1z"
      />
    </g>
    <g stroke="#000">
      <path
        fill="none"
        strokeWidth={0.7}
        d="m503.7 265.1 8.7 20.8M460 271.7c-1 6.5-2.5 14.8-4.2 21.1"
      />
      <path
        strokeWidth={0.4}
        d="M556.9 284.3a88 88 0 0 0-26.5-1.3c-5.8.4-11.7.6-17.1 2.3q-1.3.4-2.1 1c-1.6 1.5-1.7 4-3 5.7s-6 4.5-7.9 5.7c-12.5.2-26.5 0-42.3-2.3l-2-2.5-1-.9 2.4 1h5.6l13.7-.4s11.5 0 17.2-.3l9.8-.8q1.2.1 2-.4c1-.6 1.3-1.8 2-2.9.6-.8 1-2 2-2.6 2.4-1.7 5.6-1.6 8.2-2.1 3.3-.7 6.2-.8 9.5-1.3l11.2-1q3.6-.2 7.3 0c3.6.2 7.7 0 10.9 1.8.6.2 1.7.9 1.3 1.5-.3.4-.8-.2-1.3-.2z"
      />
      <path
        fill="none"
        strokeWidth={0.5}
        d="M499.5 200.3c1.9 1.5 5.3 2.7 8.7 3.2M495.6 253q-6 4.2-12.4 6.2m23.5 30.8-6.9-18m1.4-5.9 8 20.6m-9-15.3 5.3-1.8"
      />
    </g>
    <path
      fill="#bca76b"
      stroke="#472b1f"
      strokeWidth={0.4}
      d="m496.6 197.6-1.6 95.8 5.7-.3-1-95.4z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.7}
      d="M503.5 212.4q3.2 6.4 10.9 10"
    />
    <g fill="#bca76b" stroke="#472b1f">
      <path strokeWidth={0.5} d="M484.8 206.6c1.8 8.2 10.3 7 10-.6" />
      <path strokeWidth={0.7} d="M492.6 206.3c2.3 9.6 13.2 8.1 12.8-.5" />
      <path
        strokeWidth={0.5}
        d="M501.7 206.3c2.4 7 6.6 7.6 10.2-.7m2.5-2.5-30.9 1.4v2.2l31.1-1.3zm-29.6 22.8c1.8 8.2 10.3 7 10-.6"
      />
      <path strokeWidth={0.7} d="M492.6 225.6c2.3 9.6 13.2 8.1 12.8-.5" />
      <path
        strokeWidth={0.5}
        d="M501.7 225.6c2.4 7 9.5 5.8 10.2-.7m2.5-2.5-30.9 1.4v2.2l31.1-1.3z"
      />
    </g>
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.7}
      d="M494 236.5c-2.7 1.9-5.2 4-8.9 5.2"
    />
    <g fill="#bca76b" stroke="#472b1f">
      <path strokeWidth={0.5} d="M483.9 244c1.8 8.2 10.2 7 10-.5" />
      <path strokeWidth={0.7} d="M491.6 243.6c2.4 9.7 13.3 8.3 13-.4" />
      <path
        strokeWidth={0.5}
        d="M500.8 243.6c2.4 7 8.7 4.8 10.1-.5m2.5-2.5-30.8 1.3v2.2l31.1-1.3z"
      />
    </g>
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.5}
      d="M487.9 265.8c-.8 9.5-4.6 18-7.1 27m10.5-26.9c-.8 9.2-3.7 17.8-6 26.5m8.9-27.3a175 175 0 0 1-4.6 27.2"
    />
    <g fill="#bca76b" stroke="#472b1f">
      <path strokeWidth={0.5} d="M484.3 261.3c1.8 8.3 10.2 7.1 10-.5" />
      <path strokeWidth={0.7} d="M492 261c2.4 9.6 13.3 8.2 12.9-.5" />
      <path
        strokeWidth={0.5}
        d="M501.2 261c2.4 7 8.6 5.7 10.1-.6m2.5-2.5-30.8 1.3v2.2l31-1.3z"
      />
      <path
        strokeWidth={0.3}
        d="m504 216-11 .5v3h11zm-.4 18.8-9.9.2v2.8h9.9zm.5 18.1-10.5.4v2.9h10.6z"
      />
    </g>
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.5}
      d="m487.7 269.3 5.7 1.1m-7 4.2 6.6.2m-7.7 3.7 6.9 2m-8.7 4 8-.3m-9.5 5.3 8.5-.2m-10.4-23.7c-1 9.7 5.3 18.9 8.4 27m17.5-5 5.4-1.7m-6.7-1.3 6.1-2.6m-8-2 6.3-1.9m-7.8-2.5 6.2-1.6"
    />
    <path d="M468 309.7q-1.2-.1-2.2-.4l-2-.7-2-1.3-1.7-1.4-2-1.9-1.8-2q-1-.9-1.8-1.9c-.5-.5-.6-1.5-1-2-.8-.2-1.9-.3-2-1.4-.2-.6-.3-1.3-1-1.2-.4 0-.5.5-.3.2-.4-.2-.3.7-.3.2l-.5 1q-.6 1.3.6 1.6c.8.1 1 1 1.7 1.4q.8 1 1.9 1.8l1.5 2q.6.8 1.5 1.5l1.3 1.7 1.8 1.5 1.8 1 2 .9q1.1.4 2.5.4 1.2.1 2.3-.5c.7-.5 0-.4-.4-.5zm44.8-21.8a27 27 0 0 1-4.6 7.8c6.6 1.3 11.9-.5 17.8-1.5q-.8-4-.4-8.3c-4.7.5-8 1.6-12.8 2" />
    <path
      fill="#333"
      d="M513.4 288.6c-.8 2.1-1.5 4.3-3.1 6.1 5.4 1.2 9.8-.5 14.7-1.4-1-2-.7-4-.4-6.2z"
    />
    <path d="m456.5 298.2 19.1 1.4c15.4.5 33-.2 48.2-2 .6 0 1.7-.2 1.9.4s-.8 1.6-1.5 1.7c-17.5 2.3-35.2 1.4-52.8 1.3l-10.4-1.1z" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.7}
      d="M463.5 255.3c-5 3.8-9.8 7.6-15.4 9.8m16.1-27.9c-4.5 3.3-9 7.3-13.7 9.2"
    />
    <path
      fill="#bca76b"
      stroke="#472b1f"
      strokeWidth={0.4}
      d="m462.6 204.3-.1 89.5 4.9-.4-2.9-89.6z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.7}
      d="M464.5 203.8c4 4.4 7.2 6.8 10.5 9.6"
    />
    <path
      fill="#bca76b"
      stroke="#472b1f"
      strokeWidth={0.5}
      d="M465.8 201.2c-1-.5-3.7-.6-4.7.7-.6.6-.1 2.9.6 2.9 1.4 0 3.2.1 3.8-.5s1-2.7.3-3z"
    />
    <path
      stroke="#000"
      strokeWidth={0.9}
      d="M463 305.3q.3-1 1.4-1 1.4-.2 2.3.1l1.4.7 1.3 1c1.6.5.8-1.3 1.7-1.4s1.6-.3 2.2 0q.8.3 1.2 1l.9.8c.1.5 1.9 1.3 2 .2.3-.7.1-2 1.3-1.9q2 .1 3.7.4.9.3 1.7 1c.5.2.4.8.8.7 1.3 1 1-.7 1.4-1.3.3-.5 1.2-.3 1.6-.7q1.2-.4 2.6-.4l1.8 1q.6.4 1 1.3c.1.6.7 1.1 1.2.6.3-.6.8-.6 1.3-1q.8-.1 1.2-.8c.3 0 .6-.7 1-1q.9-.4 2.4-.4 1.5.3 2.3.8.4.6 1 1c.3.5 1 0 1.4-.2l1.4-.8q.6-.6 1.9-.7c1-.1 1.5.4 2.2.5q1.3.3 2 .8 1 .8 1.8.2c.7 0 .2-1.3.4-1.6.8-.6 2.7-.6 3.7-.2l2.4.2q.6.3.8 1.2c.3.5 1.8.5 2.3.1.4 0-.1-.7-.3-.9l-.8-1c.7-.4 1 .3 1.7.4l1.2.8q.7.5 2 .4c.8.3.5 1.5-.5 1.2-.7.3-1.9 0-2.7.1h-4.2l-2.6.3-2.4.1q-1.5.2-3 .1l-2.5.3-2.4.1c-1.2.3-2.7 0-4 .1l-2.3.2-2.5.2-2.6.1c-1.5.3-3 0-4.5.1l-2.5-.2H487c-.6-.3-1.7 0-2.3-.3h-9.9c-.5-.3-1.5 0-2.3-.2h-3.7c-1-.2-2 0-2.9-.4-1.3-.2-3-.6-2.8-1.7z"
    />
    <g fill="#bca76b" stroke="#472b1f">
      <path strokeWidth={0.4} d="M452.1 215.4c1.6 5.7 9 4.8 8.7-.4" />
      <path strokeWidth={0.5} d="M458.8 215c2.1 6.8 11.7 5.9 11.3-.2" />
      <path
        strokeWidth={0.4}
        d="M467 215c2 5 5.7 5.5 8.8-.3m2.1-1.7-27 1v1.4l27.2-.8z"
      />
    </g>
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.7}
      d="M459.5 226c-2.4 2-6.8 4.7-8.8 4.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.7}
      d="M454.7 218.5a672 672 0 0 1-20.5 64.3"
    />
    <g fill="#bca76b" stroke="#472b1f">
      <path strokeWidth={0.4} d="M451.9 232c1.5 6.3 9.1 5.3 8.9-.4" />
      <path strokeWidth={0.7} d="M458.2 231.9c2 8.4 12 7 11.6-.4" />
      <path
        strokeWidth={0.5}
        d="M467 231.8c2.3 5.2 6.7 5.7 10-.3m1.2-2.6-27.5 1.3v2l27.8-1zM450.3 248c1.8 7.7 10 6.5 9.7-.5"
      />
      <path strokeWidth={0.8} d="M457.9 248c2.4 11 13.8 9.5 13.4-.7" />
      <path
        strokeWidth={0.5}
        d="M466.8 247.8c2.4 6.4 6.6 7 9.9-.5m2.3-2.4-31.5 1.3.2 1.8 31.6-.9zm-29.2 21.7c1.8 8.2 10.7 7 10.5-.4"
      />
    </g>
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.7}
      d="M473.1 270.9q2.9 11.7 6.5 21.7m-8.9-22c1 7.6 3.1 14.9 5.3 22"
    />
    <g fill="#bca76b" stroke="#472b1f">
      <path strokeWidth={0.7} d="M457.9 266.3c2.2 11 13.8 10.1 13.6-.5" />
      <path
        strokeWidth={0.7}
        d="M467.6 266.3c2.6 7 7 7.6 10.6-.5m2.5-2.9-34.9 1.3v2.6l35.5-1.3z"
      />
      <path
        strokeWidth={0.3}
        d="m469.4 223.5-10 .3v2.2h10.2zm0 16.3-10 .2v2.3h10.2zm.7 17.7-10.8.3v2.2h11z"
      />
    </g>
    <g fill="none" stroke="#000">
      <path
        strokeWidth={0.5}
        d="m474.1 273.2-5.7 1.2m6.6 3.1-5.7 1.2m7 3.6-5.8-.3m7.5 4.8-6 1m-20.8-1.9 6 1.2m-4.3-6.1 5.4 1.2m-4-5 5 1.3m-4-4.7 4.5.9"
      />
      <path d="M526.9 293.9c10-.5 22-1.7 30.2 1.5m-29.5 1.8c9.2-1.4 20-2.1 28 .9m-27 5.8a53 53 0 0 1 22-.3m-21.3 1.9a48 48 0 0 0 20.8.2" />
    </g>
    <path d="m431.5 282.1 21.7 13 .5-.5-6.8-4.7c-5-3-9.8-6-15.4-7.8" />
    <g fill="none" stroke="#000">
      <path
        strokeWidth={0.5}
        d="m535.7 292.8-.2-7.2m2.4 0v7.5m4 0v-7.7m4.6.7v7.4m2.7-7.5v7.6m3.6-6.8v7m1.8-7.1v7.9m-18 1.4v6.8m-2.3-6.5v6.5m6-6.7-.3 6.5m2.5-6.6-.1 6.5m3.4-6.5-.4 6.2m3.5-5.4-1.2 5.8"
      />
      <path d="M527 286c10-1.2 19.9.3 29.8 1.3" />
    </g>
    <path
      fill="none"
      stroke="#000"
      strokeWidth={2}
      d="M581.1 197c.1-25.6-1.3-50.4-.7-72.1-33-14.7-76.6-17.7-98.7-17.7s-65.8 3-98.8 17.7c.6 21.7-.8 46.5-.7 72z"
    />
    <path
      fill="#69737c"
      stroke="#000"
      strokeWidth={0.7}
      d="M475.7 155.4s3.6 5.4 4.6 8.2q.7 2.3.5 4.4c-.2 2.7-1.2 5.3-2 7.8-.6 1.8-2 3.2-1.2 4.9.3.8.7 1.6 1.6 1.5.5-.1.8-.8 1.2-1.2l1-.6c.5-.2 1.2.1 1.6-.3q.6-.6.3-1.4c-.3-.3-.8 0-1.3 0s-1.2.5-1.7.2-.8-1.7-.8-1.7l1.6-4.4c.5-1.2 1.3-2.3 1.5-3.6V168c0-.7-.2-1.4.3-2 .2-.2 1 .2 1.2-.2.6-1.5-2.1-2.5-2.8-4l-.2-1.7c-.5-1.3-2-3.5-2-3.5z"
    />
    <path
      fill="#66452b"
      stroke="#000"
      strokeWidth={0.7}
      d="M486.9 159.6s3.1 4 3.5 6.3l-.4 1.6c0 .8.5 1.6.5 2.5-.2 2.7-1.6 5.2-2.3 7.8l-1.4 6.7 2-.2.4-3.4 1.5-5.8 1-4 1.3-2.5c.2-1.2.6-2.5 0-3.6q-.4-.5-1-.7a10 10 0 0 1-1.6-2.5c-.5-1-1-3-1-3-.5.3-2.5.8-2.5.8z"
    />
    <path
      fill="#fff"
      d="m471.9 152.3 2.3 1.9 3.8 2.3 1.9.2 2 .7 2.6-.1 1.9 2 .4.3 2.2-.3.8-.9 4-6-1-10-19 1.1z"
    />
    <path
      fill="#fff"
      d="M492.4 135.4a41 41 0 0 1 7.1 7c1.5 1.8 2.4 4.3 4.8 5.4 3.2 3.4 16.9 7.4 17 8.5-3.2-1.3-4.6 3-7.7 2.3-2.8.8-5.2-1-7.6-2-3.8-.2-7.6 0-10.9 1.9-1.8 1-3.9-.5-5.3 0l-.2.2-.2.2m-17.5-6.5c-2.2-1.1-3.8-3.2-5.9-4.4-1.5-2.2-3.6-4.5-3.5-7.4-.2-3-1-7.2.4-10-1-2.3-2.4-3-3.6-5.1-.8-3.1-3.9-4.9-2-7.2 2-1.9 3.5-4 6.2-5a12 12 0 0 1 6.6.5c2.7.3 4.2 2.6 5.7 4.7a23 23 0 0 1 3.4 9.1c1.3 2.6 4.7 3.2 7.2 4.3 2 1 4.2 1.9 6 3.5"
    />
    <path d="M507.4 153.2c-1-.1-3.6 1-3-.7-2.6-.2-5.4.4-8-.5a47 47 0 0 0-8.3-2.9c-2.7 0-6 .5-8.1-1.7-2.2-1.3-5.4-.4-7.4-2.3a9 9 0 0 1-3.3-6.8c-.3-2.6-1.3-6.1 1.6-7.7 2-.6 3.8 0 5-2a10 10 0 0 1 6.7 1.7c2.5 1.2 5.3 2 7.7 3.4 2.3 1.5 4.2 3.5 6.4 5.2 1.7 2 3.7 3.7 4.8 6.1 1.3 2.6 4 4 6.3 5.4 1.3.4 4.6 2 1.5 2.3l-2 .5z" />
    <path
      fill="#69737c"
      d="M480.5 144.6a8 8 0 0 1-4-1.3c-.7-.5-3-1.8-1.5-2.8 1.1-.1 2.5.5 3.5-.4 1.6-.3 3.2-.3 4.7-1 1.4-.8 3-.3 4.4-.8 1-.5.8-2.6 2.4-2.2 1.5-.4 1 2.4-.2 1.5-.9 1.1 1.4 1.5 2 2.2 1.2 1.4-1.5 1.7-1.7 2.7-1.7.5-3-1.6-4.6-1-.3.5 0 1.7-1.1 1.4-1.5-.9-2.7.1-4 .3.4.3-.6 1.5 0 1.4zm29.1 10c-.8-.4-1.8 0-2.7 0q-.9 0-1.7-.2c-.9 0-2.5-1-2.8.3 0 .5 1.5.8.3 1q-1.6 0-3.3-.8c-.5-.4-1.4-1-1.1 0s-.6 1.3-1.4 1.3a5 5 0 0 1-3-1.1c-.6.6.8 1.6 1.6 1.7.8.6-1.2.4-1.7.3q-1-.3-2 .2c-1 .2-1 1.1.1 1 1 .3 2.2.7 3.3.2a9 9 0 0 1 3.6-1.4l3-.5h4.1q1.7.4 3-.5c.7-.2 2.4-.9 1.2-1.4z"
    />
    <path d="M506 156.5q.8 0 1.4-.2l1.7-.6c.7 0 1-1 .3-1.1l-1.3-.7-1.4-.8 1-1.2 1.5-.3h1.2l1.7.7 1.7.8 1.5.4q.8.4 1.7.6c.6.2.8.8 1.5.7q1 .2 1.8.7.8.3 1 .9c-.5 0-1-.5-1.5-.3-.5 0-.8.5-1.3.4-.2.6-1 .5-1.4 1.1l-1.9 1.1a2 2 0 0 1-1.6 0l-1.8-.2q-1 .2-1.9-.1t-1.4-.9l-2.1-.7-.6-.3zM465 113l-1.6.2q-1.4.3-2.4 1.4a13 13 0 0 1-2.6 2.4l-1.2 1.3q1.1.7 1.9-.2 1-1.1 2.3-1.7c.8-.2 1.6.2 2.4.2a5 5 0 0 0 2 .8l1.6.3 2.2.6q1.4.2 2.6 0h.6l-.2.6q0 .8.5 1.5l.8 1.3.7 1.6.6 1.3q.1.8.7 1.3l1 1.4.8 1.3c.3.3.7.8 1.2.7l1.6-.2h-.2q-.7-.5-1-1.3l-.2-1.5q0-.8-.4-1.5l-.4-1.2-.5-1.3-.7-1.5-.7-1.4-.8-1.3-.6-.5q0-.3-.3-.7-.7-.7-1.1-1.5-1.1-1-2.5-1.3l-3-.9-2.5-.2h-.5z" />
    <path
      fill="#69737c"
      d="M474.6 126.5c0-.7-1-.5-1.3 0L472 128c-1 .7-2 .8-3 1.4q-.5.9-1.5 1.5-1.2.5-1.8 1.5c-.1.5-.5 1.3 0 1.7.7.3 0 1 .1 1.4.3.5 1.2.7 1.7.4q1-.7 1.8-1.5 1-1.3 2.3-2a3 3 0 0 0 1.5-1c.5-.4 0-1 .8-1.2q.9-.5 1.3-1.3c.4-.6-.3-1.1-.2-1.7q0-.3-.3-.7z"
    />
    <path
      fill="#66452b"
      stroke="#000"
      strokeWidth={0.7}
      d="M485.2 185h-3.7c-.6-.2-1-1.2-1.9-.8q-1 .3-1.9 1a5 5 0 0 0-1.6 1.3c-.1.4-1.2.8-.2.8.8.1 1.3-.8 2-.9.7-.3 1.5 0 2-.1h1.8l2 .2c.9 0-.4.6-.7.8q-1 .4-2.3.5t-2.3.3l-2 1.2c-.4.2-1.4.7-.4.7q1 0 1.9-.3l3.4-.9 2.3-.6c.5 0 1.7-.3 1.3.6a4 4 0 0 1-1.8 1.3q-.8.6-1.9.8c-.5-.2-1.7.2-.8.8.4.7 1.3.2 1.8 0l2-.9 2.2-1 2-.8q1-.5 1.7-1.5.4-.9 1.3-1.2c.7-.2 1.4 0 2-.2.8 0 .6-1.4-.1-1.5l-1.8-1.2q-1-.5-2.3-.4a2 2 0 0 0-1.6 1c-.4.5-.5 1.4-1.3 1.2q-.6.1-1.1-.2zm-18 4.6s.6-2.5 1.5-3.4c2-1.9 7.2-3.2 7.2-3.2-2.3 1-5 .2-7.2.9-1.8.5-4.9 2.9-4.9 2.9s1.2-2.5 2-3.5c2.7-2.9 6.8-3.2 10-2.7l3.6.4s.6.4.3 1c-.5 1.1-2.2 1.8-3.4 2.3-3.2 1.7-7.2 3-9.2 5.3z"
    />
    <path
      fill="#69737c"
      stroke="#000"
      strokeWidth={0.7}
      d="M478 180.6c-2.9 1.9-9.5 5.4-9.3 5.6 0 0 5.7-1.3 8.3-2.6.9-.4 2.2-.7 2.5-1.7q.1-.8-.5-1.4a1 1 0 0 0-1 0z"
    />
    <path
      fill="#69737c"
      d="M491.7 165.4c-.6 0-.7 1.3-.8 2 0 .5 0 1.4.5 1.4s.8-1 .8-1.7c0-.5.1-1.6-.5-1.7"
    />
    <path
      fill="#69737c"
      stroke="#000"
      strokeWidth={0.7}
      d="M488.8 184.3c0-.5-.7-.2-1-.1q-1 .2-1.9.9l-1.4.9-2.9 1.5-1.3.5q-.4.2.1.2 1 .3 2-.1l2.2-.7 1.6-.7c.3-.2 1.3-.4 1.6-.5.6-.4.4-.8 1.1-.8.5 0 .5-.7 0-.8v-.3z"
    />
    <path
      fill="#69737c"
      stroke="#000"
      strokeWidth={0.7}
      d="M482.3 190.4q.8 0 1.5-.3l1.9-.6.8-.4a4 4 0 0 0 1.2-1.4l.7-1.3q0-.6-.6-.3l-1 .8-1 .8-1 1.4-.6.4-1.6.7z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.7}
      d="m489.2 152.9.4 1 .2 1.5c0 .5-.5.8-.6 1.3v1c-.2.5 0 1-.2 1.6-.3.5-1 .1-1.5.2q-.8.3-1.1-.3l-1.2-1.2q-.8-.7-1.3-1.5l-.9-1.4-.2-.5m1.7 2.7h-2.6c-.3 0-1 0-1.2-.3q-.4 0-.8-.3h-.7q-.4-.7-.9-1.1l-.7-.5-.5-.6-.5-.8-.4-.8v-.2m3 4c-.1.5-.8 0-1.1-.2l-.8-.3-.7-.4-.8-.5-1-.5-1-.8q-.8-.4-1.2-1-.7-.3-.7-1l-.3-1.2-.1-.5"
    />
    <path
      fill="#bca76b"
      d="m507.4 157 1.2-.2 1.2-.2q.5-.5 1.1-.5.8 0 1.3-.2a1 1 0 0 1 1-.4q.6 0 1.1.2l1.1.3 1 .5c.4.2-.2.5-.3.6-.4.2-.8 0-1.1.3q-.6.3-.8.8-.4.4-1 .4h-1q-.5.2-1 0l-1-.2q-.5-.4-1-.5l-1.5-.7z"
    />
    <path
      stroke="#000"
      strokeWidth={0.5}
      d="M459.6 122.7c-.9-.2-1.8.2-2.6.2h-5.2c-1.3.3-2.6.9-3.9 1l-5.3.1c-1.3.1 0-1.5.8-1.5q2.4-.8 4.9-1.2l3.7-.7 3-.8q1.7-.4 3.2-.2l3.3-1c1-.5 2-.2 3-.8.5-.8 1.5-.7 2.5-.7q1.6.2 2.5 1.4c.7 1-1.4.9-.8 2q-.7.4-1.6.4c-.9 0-1.1 0-1.5-.2l-2.2-1.3c-.8-.2-.9 1.3-1.8 1.1-1.2.5-2.6.3-3.9.4q1.3.4 2.4 1.2c.3.4-.2.4-.5.5z"
    />
    <path
      fill="#fff"
      d="m464.8 119.1.8-.3.5-.8s.7 1 .3 1.4-1.6-.3-1.6-.3m2.2-2c.1 0-.7-.6 0-.8.6-.7 1.6-.1 2.4.1q2.4.6 4 2.4c1.5 1.6 1.8 3.8 3 5.7l1 2.8c.3.7 1.4 1.5.8 2.3-.7.4-1.4-.2-2-.3-1-.1-.5.9 0 1 .7.3 1 1.3 0 1.2l-2.6-.3c-.7-.4.2-1 .6-1.3s1.2-.7 1-1.4c0-1.2-.8-2.3-1-3.5q-.3-1.4-.9-2.7c-.4-2-2.2-3.3-4-3.9l-2.3-1.1z"
    />
    <path
      fill="#bca76b"
      d="m473.5 118.1.8.4.8 1.2.2.7q.1.4.5.7l.3 1 .4 1 .3.7q.3.5-.2.6l-.6-.3-.7-1-.2-.6-.3-1-.4-.7-.4-1c-.1-.3-.7-1.1-.6-1.5zm-5.9-2.2-.4-.3-.6-.3c-.4.1-.1-.3-.3-.2l-.2-.5-.3-.4s-.2-.2 0-.2l.6.1.5.1h1.1l.3.1q.3.1.4.4l.3.5v.4l-.5.2-.6.2z"
    />
    <path
      fill="#fff"
      d="m467.1 115.6-1 .1-.4.4-.6.2-.5-.3-.3-.3-.4-.2q-.2 0-.2-.4v-.5l.4-.2h1l.7-.1.4.3zm1.6-.9.7-.2.7.1q.5 0 .8.3l.8.4.7.3.7.4.6.6q.1.4-.3.4l-.7-.4-.7-.2-.7-.3-1-.4-.5-.1-.9-.5q-.2-.1-.2-.4"
    />
    <path d="M472.4 120c-1 0-2 .4-3 0-.7 0-1.3.6-2 .8-.8-.1-1 1.1-1.7 1-.7 0-1.4-.5-2-.3q2 .8 3.8 2a6 6 0 0 0 2 1.3c.7.3 1.3.8 1 1.5-.2.8-1.4 1-1.4 1.8-.1.8-1 1.2-1.3 1.8s-1 1-1 1.6c.1.8 1 .2 1-.4.2-.5.7-1.4 1.4-1 .5.7 1.2-.6 1.8-.3q.7.9 1.3.1c.5-.2 1.2-.5.7-1 0-.7.8-.7 1.2-1 .5-.2 1-1 .5-1.4-.5-.7 0-1.7-.6-2.3-.5-.7 0-1.7-.4-2.4q-.4-1.2-1.2-1.8z" />
    <path
      fill="#69737c"
      d="M499.2 147.2c-1 0-2 .9-3.2 1s.4.8.8 1c1.1.8 2.4 1 3.6 1.5q1.8.9 3.7.6c1.1-.3.3-1.4 0-2-.7-1-2-1.5-2.8-2.4q-1.2-.7-2 .3z"
    />
    <path
      fill="#fff"
      d="m498.4 149.7-1.2.1q-.8.2-1.5-.1l-1.4-.5q-.7-.3-1.1-.8c-.3-.4.3-.4.6-.4q.7-.3 1.6-.2l1.7.8q.8.3 1.3.8zm5.6-.4c.1.5-.7 0-1 .2a3 3 0 0 1-1.6-.3q-1.4-.7-2.7-1c-.4-.1-1.3-.5-.6-1a3 3 0 0 1 1.7-.8l1.8.6q.9.4 1.7 1t.8 1.3z"
    />
    <path
      fill="#69737c"
      d="M488.6 143.8a5 5 0 0 1-2.8.7c-.9.3-2.3-.5-2.6.6-.4 1 .7 1.4 1.3 1.8 1.8 1 3.8 1 5.7 1 .6 0 2.3-.2 1.4-.8q-1.5-1.2-2.5-2.7zm9.8.6-1.2-.3-1.4-.8-2-1q-.5-.4 0-.6c.4 0 .6-.5 1-.1q.6.3 1.1 1t1.4.8q.8.4 1 1zm-1.4 1.8s-1.7.5-2.5.2q-1-.2-1.8-.6-1.2-.5-2-1.3c-.5-.5 0-1.4.8-1.2.4-.1.2-1 1-.6s1.7.8 2.4 1.4l1.5 1.3zm-13.2-12.4c1.2.3 2.6.8 3.3 2 1 1.1-1 1.9-2 1.1q-2.2-1.1-4.5-2c-1.6.3.6 1.2 1 1.5q1.3.9 1.3 2c-1 .8-2.3 0-3.4-.2-1.2-.1-2-1.2-2.7-2q-.9-1-2-.6c0 1 .8 1.3 1.3 2.2.4.5 2 1.8.5 1.9a5 5 0 0 1-2.9-2.2c-.7-.7-1.2-2.2.2-2.4q2-1 4.2-1c1.5-.2 3.1 0 4.7-.4.2 0 1.2-.5 1 0z"
    />
    <path
      fill="#fff"
      d="m471.9 134.7-.4 1v1.2l.4 1q.3.6.8.8.3.4.8.6l.7.4 1 .2q.5 0 .7-.3.3-.3-.2-.5-.4 0-.7-.5l-.7-.7q0-.4-.4-.8l-.6-.7-.7-.7-.6-.8zm10.4 4-2.6-.5a5 5 0 0 1-2.2-1.6q-1-1-2-1.7c-.9-.3-1.2.9-.7 1.3l1.6 2 2 1.4a7 7 0 0 0 3.1.8q1.2-.1 1.6-1-.2-.7-.8-.6zm-2.4 5.4q-.9 0-1.7-.3a3 3 0 0 1-1-1.2q-.8-.9-1.5-1.1c-.5-.1-1.2.2-1 .8q.1.7.8 1.3 1 .7 2 1.1.6.3 1.2.2c.5 0 1 .2 1.2-.3zm5.9-1.7q.8.4.5 1.3-.6.8-1.7.8l-1.6-.1-1.7-.8c-.6-.2-.7-.9-1-1.3s.5-.7.9-.6c.5.2 1 .8 1.4 1l1.5.5c.4 0 1 .2 1.2-.2l.4-.6zm5-1.3c.5.4.2 1.3-.5 1.5h-1.4l-2-1q-.8-.3-1.3-.9c-.2-.6.5-1 1-.8q1.2.2 2.4.8.7.4 1.7.5z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.7}
      d="M492.4 135.4a41 41 0 0 1 7.1 7c1.5 1.8 2.4 4.3 4.8 5.4 3.2 3.4 16.9 7.4 17 8.5-3.2-1.3-4.6 3-7.7 2.3-2.8.8-5.2-1-7.6-2-3.8-.2-7.6 0-10.9 1.9-1.8 1-3.9-.5-5.3 0l-.2.2-.2.2m-17.5-6.5c-2.2-1.1-3.8-3.2-5.9-4.4-1.5-2.2-3.6-4.5-3.5-7.4-.2-3-1-7.2.4-10-1-2.3-2.4-3-3.6-5.1-.8-3.1-3.9-4.9-2-7.2 2-1.9 3.5-4 6.2-5a12 12 0 0 1 6.6.5c2.7.3 4.2 2.6 5.7 4.7a23 23 0 0 1 3.4 9.1c1.3 2.6 4.7 3.2 7.2 4.3 2 1 4.2 1.9 6 3.5"
    />
  </svg>
);
export default SvgShHl;
